import React, { useEffect, useCallback, useState} from 'react';
import {getLeafString} from 'effects/midi/tidal/parser.js';
import {expandCycle} from 'effects/midi/tidal/tidal.js';
import Colors from 'components/Colors.js';
import {connect} from 'react-redux';
const colors = new Colors();

const TidalVisualizer = ({effect, cycle, currentCycles=[]}) => { 
    return (
        <div className="tidal-visualizer">
          <TidalPart effect={effect} cycle={cycle} total={100} currentCycles={currentCycles}/>
        </div>
    );
}

const TidalPart = ({effect, cycle, total, currentCycles}) => {
    let style = {
        width: total + '%'
    };
    let totalLength = 0;

    const getOperand = useCallback((operand) => {
        if (typeof operand === "object") {
            return Math.max(1, Math.floor(effect.var(operand.name)()));
        }
        return Math.floor(operand);
    }, [effect]);

    if (!Array.isArray(cycle)) {
        if (cycle.cycle) {
            // theres a cycle within it
            for (let part of cycle.cycle) {
                totalLength += part.operator === "*" ? getOperand(part.operand) : 1;
            }
        } else {
            style.backgroundColor = cycle.transpose === null ? 'gray' :
                colors.getColorForHash(getNumberString(getLeafString(cycle)));
        }
    } else {
        for (let part of cycle) {
            totalLength += part.operator === "*" ? getOperand(part.operand) : 1;
        }
    }
    let className = "tidal-part";
    if (currentCycles.some(c => c.cycle === cycle.id)) {
        className += " current";
    }

    return (
        <div
          style={style} className={className}>
          {Array.isArray(cycle.cycle || cycle) ?
           (cycle.cycle || cycle).map((part,i) =>
                     part.operator === "*" ?
                     new Array(getOperand(part.operand)).fill(0).map(
                         (p,j) =>
                             <TidalPart
                               effect={effect}
                               key={i+'-'+j}
                               cycle={part}
                               total={100 / totalLength}
                               currentCycles={currentCycles}/>) :
                     <TidalPart
                       effect={effect}
                       key={i}
                       cycle={part} total={100 / totalLength} currentCycles={currentCycles}/>) :
           <span>{getLeafString(cycle, true)}</span>}
        </div>
    );
};

const getNumberString = (x) => {
    if (typeof x === 'string') {
        return x;
    } else {
        return x ? x.toString() : 0;
    }
};

const mapStateToProps = (state, props) => {
  return {
      cycle: props.effect.cycle,
      currentCycles: props.effect.currentCycles
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TidalVisualizer);
